import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
  Heading,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
} from "@chakra-ui/react";

import AdminLogin from "../AdminNav/Login";
import { MyContext } from "../../MyProvider";

import { PageHeader, SectionTitle } from "../../components/ui";

function Submissions() {
  const {appointData,eventData,horoData} =useContext(MyContext);

  const [todaySubmissions, setTodaySubmissions] = useState([]);
  const [alreadySubmissions, setAlreadySubmissions] = useState([]);

  const todaySubmissionsList = [];
  const alreadySubmissionsList = [];


  useEffect(() => {
        const today = new Date();
        
        appointData.forEach((person) => {
          const SubmissionDate = person.bookingDate; // Assuming "DOB" is the date of birth property
          const fullName = person.fname + " " + person.lname;
          const contact = person.phone;
          const textInfo = "Appointment / Contact";
          const userid = person.userId;

          // Check for null DOB or empty string
          if (!SubmissionDate) {
            return;
          }

          // Parse DOB in "dd/mm/yyyy" format
          const SubmissionDateParts = SubmissionDate.split("/");
          if (SubmissionDateParts.length !== 3) {
            return;
          }
          const curdate = parseInt(SubmissionDateParts[0], 10);
          const curmonth = parseInt(SubmissionDateParts[1], 10) - 1;
          const curyear = parseInt(SubmissionDateParts[2], 10);

          if (curdate === today.getDate() && curmonth === today.getMonth() && curyear === today.getFullYear()) {
            todaySubmissionsList.push({
              fullName,
              SubmissionDate,
              contact,
              textInfo,
              userid,
              curdate,
              curmonth,
              curyear,
            });
          } else {
            alreadySubmissionsList.push({
              fullName,
              SubmissionDate,
              contact,
              textInfo,
              userid,
              curdate,
              curmonth,
              curyear,
            });
          }
        });

        eventData.forEach((person) => {
          const SubmissionDate = person.bookingDate; // Assuming "DOB" is the date of birth property
          const fullName = person.fname + " " + person.lname;
          const contact = person.phone;
          const textInfo = "Event - " + person.eventName;
          const userid = person.userId;

          // Check for null DOB or empty string
          if (!SubmissionDate) {
            return;
          }

          // Parse DOB in "dd/mm/yyyy" format
          const SubmissionDateParts = SubmissionDate.split("/");
          if (SubmissionDateParts.length !== 3) {
            return;
          }
          const curdate = parseInt(SubmissionDateParts[0], 10);
          const curmonth = parseInt(SubmissionDateParts[1], 10) - 1;
          const curyear = parseInt(SubmissionDateParts[2], 10);

          if (curdate === today.getDate() && curmonth === today.getMonth() && curyear === today.getFullYear()) {
            todaySubmissionsList.push({
              fullName,
              SubmissionDate,
              contact,
              textInfo,
              userid,
              curdate,
              curmonth,
              curyear,
            });
          } else {
            alreadySubmissionsList.push({
              fullName,
              SubmissionDate,
              contact,
              textInfo,
              userid,
              curdate,
              curmonth,
              curyear,
            });
          }
        });
        horoData.forEach((person) => {
          const SubmissionDate = person.horoDate; // Assuming "DOB" is the date of birth property
          const fullName = person.fname + " " + person.lname;
          const contact = person.phone;
          const textInfo = "Astrology";
          const userid = person.userId;

          // Check for null DOB or empty string
          if (!SubmissionDate) {
            return;
          }

          // Parse DOB in "dd/mm/yyyy" format
          const SubmissionDateParts = SubmissionDate.split("/");
          if (SubmissionDateParts.length !== 3) {
            return;
          }
          const curdate = parseInt(SubmissionDateParts[0], 10);
          const curmonth = parseInt(SubmissionDateParts[1], 10) - 1;
          const curyear = parseInt(SubmissionDateParts[2], 10);

          if (curdate === today.getDate() && curmonth === today.getMonth() && curyear === today.getFullYear()) {
            todaySubmissionsList.push({
              fullName,
              SubmissionDate,
              contact,
              textInfo,
              userid,
              curdate,
              curmonth,
              curyear,
            });
          } else {
            alreadySubmissionsList.push({
              fullName,
              SubmissionDate,
              contact,
              textInfo,
              userid,
              curdate,
              curmonth,
              curyear,
            });
          }
        });

        alreadySubmissionsList.sort((a, b) => {
          if (a.curyear === b.curyear) {
            if (a.curmonth === b.curmonth) {
              return b.curdate - a.curdate;
            } else {
              return b.curmonth - a.curmonth;
            }
          } else {
            return b.curyear - a.curyear;
          }
        });

        setTodaySubmissions(todaySubmissionsList);

        setAlreadySubmissions(alreadySubmissionsList);
      
  }, [appointData,eventData,horoData]);

  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }

  return (
    <>
      <PageHeader title="Submissions" subtitle="Forms sent in from the website" />
      <SectionTitle>Today ({todaySubmissions.length})</SectionTitle>
      <TableContainer borderRadius="lg" border="1px solid" borderColor="stone.200">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Form Type</Th>
              <Th>Full Name</Th>
              <Th>Submission Date</Th>
              <Th>Contact</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {todaySubmissions.map((person, index) => (
              <Tr key={index}>
                <Td>{person.textInfo}</Td>
                <Td>{person.fullName}</Td>
                <Td>{person.SubmissionDate}</Td>
                <Td>{person.contact}</Td>
                <Td>
                  <Link to={`/admin/usersDtails/${person.userid}`}>
                    <Button variant="outline" size="sm"
                    >
                      View User
                    </Button>
                  </Link>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <SectionTitle>Earlier ({alreadySubmissions.length})</SectionTitle>
      <TableContainer borderRadius="lg" border="1px solid" borderColor="stone.200">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Form Type</Th>
              <Th>Full Name</Th>
              <Th>Submission Date</Th>
              <Th>Contact</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {alreadySubmissions.map((person, index) => (
              <Tr key={index}>
                <Td>{person.textInfo}</Td>
                <Td>{person.fullName}</Td>
                <Td>{person.SubmissionDate}</Td>
                <Td>{person.contact}</Td>
                <Td>
                  <Link to={`/admin/usersDtails/${person.userid}`}>
                    <Button variant="outline" size="sm"
                    >
                      View User
                    </Button>
                  </Link>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
}

export default Submissions;
